module.exports = __webpack_public_path__ + "img/gb9116_1.prt.82c248a3.jpg";